import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import { Integrations } from "../entities/integrations";
import FirestorePipe from "../utils/pipe";

class IntegrationsDB extends FirestorePipe {

    public static readonly colName = 'Integrations'

    constructor() {
        super(IntegrationsDB.colName);
    }

    public create(data: Integrations): Promise<any> {
        throw new Error('not inplemented')
    }
    public define(storeId: string, data: Integrations): Promise<any> {
        return this._define(storeId, data)
    }
    public update(storeId: string, data: Integrations): Promise<any> {
        return this._update(storeId, data);
    }
    public delete(id: string): Promise<any> {
        return this._delete(id);
    }
    public getAll(...params: QueryConstraint[]): Promise<Integrations[]> {
        return this._getAll<Integrations>(...params);
    }
    public get(id: string): Promise<Integrations> {
        return this._get(id);
    }
    public getByStoreId(storeId: string): Promise<Integrations> {
        return this._get(storeId);
    }
    public on(listener: (data: Integrations[]) => void, ...params: QueryConstraint[]): Unsubscribe {
        return this._on(listener, ...params);
    }

}

export default IntegrationsDB;